import { useEffect, useCallback } from 'react';

export const useLocalCountdown = (
  minutesInit: number,
  secondsInit: number,
  onAction: (minutes: number, seconds: number) => void
) => {
  const resetCountdown = useCallback(() => {
    onAction(minutesInit, secondsInit);

    localStorage.setItem(
      'pass-reset-code-expir',
      JSON.stringify(Date.now() + minutesInit * 60 * 1000)
    );
  }, [minutesInit, secondsInit]);

  useEffect(() => {
    const passResetCodeExpir = localStorage.getItem('pass-reset-code-expir');

    if (passResetCodeExpir) {
      const passResetCodeExpirParsed = JSON.parse(passResetCodeExpir);

      const diff = passResetCodeExpirParsed - Date.now();

      if (diff < 0) {
        resetCountdown();
      } else {
        if (diff / (1000 * 60) >= 1) {
          const minutes = Math.floor(diff / (1000 * 60));
          const milliSeconds = diff - minutes * 60 * 1000;

          onAction(minutes, Math.floor(milliSeconds / 1000));
        } else {
          onAction(0, Math.floor(diff / 1000));
        }
      }
    } else {
      resetCountdown();
    }
  }, [resetCountdown]);
};
